import { render, staticRenderFns } from "./CreateArStickersModal.vue?vue&type=template&id=5f476ac0&"
import script from "./CreateArStickersModal.vue?vue&type=script&lang=ts&"
export * from "./CreateArStickersModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateArStickersModal.vue?vue&type=style&index=0&id=5f476ac0&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports